import { api } from '..';

export function getPlans(payload) {
  return api('GET', `/plans`, payload);
}
